import { parseTimelineFilter } from '@/components/common/Filter/TimelineFilter/utils'
import { ReportFiltersValues } from '@/features/Analytics/stores/useAnalyticsFiltersStore/types'
import { SaveReportRequestParams } from '@/hooks'

export const mapBillingFiltersSaveParams = (
    validActiveFilters: ReportFiltersValues
) => {
    const timelineValue = parseTimelineFilter(validActiveFilters.timeline)

    const params: SaveReportRequestParams = {
        nodeIds: validActiveFilters.node,
        commodityTypeIds: validActiveFilters.commodity,
        facilityIds: validActiveFilters.facility,
        providerIds: validActiveFilters.provider,
        contractIds: validActiveFilters.contract,
        panIds: validActiveFilters.account,
        tagIds: validActiveFilters.tag,
        usnAccountIds: validActiveFilters.usn,
        invoiceNumbers: validActiveFilters.invoiceNo?.map((id) =>
            id.toString()
        ),
    }

    if (validActiveFilters.timeline.type === 'is') {
        return {
            ...params,
            timeline: validActiveFilters.timeline.value,
        }
    } else {
        return {
            ...params,
            startDate: timelineValue.startDate,
            endDate: timelineValue.endDate,
        }
    }
}
